import { ProjectOverviewBase } from "@/components/ui/project-overview";
import {
  IElementsSubscriptionsFeatures,
  Mode,
  SceneFilterLookAtInitialState,
} from "@/modes/mode";
import { selectAllCadModels } from "@/store/cad/cad-selectors";
import {
  selectCanReadCAD,
  selectCanReadPointCloud,
} from "@/store/subscription-features/subscription-features-selectors";
import { isIElementOrthomosaic } from "@/types/ielement-extra-types";
import { isIElementValidPointCloudStream } from "@/types/type-guards";
import { selectChildDepthFirst } from "@faro-lotv/app-component-toolbox";
import {
  IElement,
  isIElementGaussianSplats,
  isIElementImg2d,
  isIElementImg360,
} from "@faro-lotv/ielement-types";
import { FlyWalkOverlay } from "./flywalk-overlay";
import { FlyWalkScene } from "./flywalk-scene";
import { FLY_WALK_MODE_INITIAL_STATE } from "./flywalk-state";
import { FlyWalkTransition } from "./flywalk-transition";

export const flyWalkMode: Mode<SceneFilterLookAtInitialState> = {
  name: "walk",
  initialState: FLY_WALK_MODE_INITIAL_STATE,
  ModeScene: FlyWalkScene,
  ModeTransition: FlyWalkTransition,
  ModeOverlay: FlyWalkOverlay,
  ModePanel: ProjectOverviewBase,
  canBeStartedWith: canFlyWalkBeStartedWith,
};

function canFlyWalkBeStartedWith(
  activeElement: IElement,
  { iElements, subscriptionFeatures }: IElementsSubscriptionsFeatures,
): boolean {
  if (isIElementImg2d(activeElement) || isIElementOrthomosaic(activeElement)) {
    return true;
  }

  const activePano = selectChildDepthFirst(
    activeElement,
    isIElementImg360,
  )({ iElements });
  if (activePano) {
    return true;
  }

  if (
    selectCanReadCAD({ subscriptionFeatures }) &&
    selectAllCadModels({ iElements }).length
  ) {
    return true;
  }

  if (
    selectChildDepthFirst(
      activeElement,
      isIElementGaussianSplats,
    )({ iElements })
  ) {
    return true;
  }

  return (
    selectCanReadPointCloud({ subscriptionFeatures }) &&
    !!selectChildDepthFirst(
      activeElement,
      isIElementValidPointCloudStream,
    )({ iElements })
  );
}
